export default function teamReducer(state = { local: [], database: [], status: {} }, action) {
  switch (action.type) {
    case 'LOAD_TEAMS_SUCCESS':
      return standardReturn(action.database);
    case 'UPDATE_TEAMS_SUCCESS':
      return standardReturn(action.database);
    default:
      return state;
  }
}

/* Create a local copy for editing and sort it */
function standardReturn(database) {
  database = database.sort(sort);
  const local = [];
  for (const entry of database) { local.push(Object.assign({}, entry)); }
  return { local, database, status: {} };
}

function sort(a, b) {
  if (a.active && !b.active) { return -1; }
  if (!a.active && b.active) { return 1; }
  if (a.ext_team_id < b.ext_team_id) { return -1; }
  if (a.ext_team_id > b.ext_team_id) { return 1; }
  return 0;
}
